import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { UitkRadioButtonGroup, UitkRadioButton } from 'uitk-react-radio-button';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading } from 'uitk-react-text';
import { ActivityDestinationViewSearch } from '../../../common/__generated__/api';
import { useStores } from '../../../utils/hooks';
import { getSelectedFieldValue, radioFilterClickHandler } from './filter-helper';

import Options = ActivityDestinationViewSearch.__ShoppingSelectableFilterOptionInlineFragment;

export interface RadioProps {
  inDialog?: boolean;
  field: ActivityDestinationViewSearch.ShoppingSelectionFieldInlineFragment;
}

export const Radio: React.FC<RadioProps> = observer(({ inDialog, field }) => {
  const { analytics, activitySearchStore } = useStores();
  const location = useLocation();
  const history = useHistory();
  const selectedFieldValue = getSelectedFieldValue(field, activitySearchStore);

  const radioClickHandler = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const [fieldId, fieldVal] = event.target.id.split('-');
    const targetOption = field.options?.find((option) => option.value === fieldVal);
    analytics.trackEvent(targetOption?.selectAnalytics?.referrerId, targetOption?.selectAnalytics?.linkName);
    radioFilterClickHandler(fieldId, fieldVal, activitySearchStore, history, location, inDialog);
  };

  return (
    <>
      {field.primary && (
        <UitkSpacing padding={{ blockstart: 'four', blockend: 'two' }}>
          <UitkHeading size={6} data-testid={'filter--name'}>
            {field.primary}
          </UitkHeading>
        </UitkSpacing>
      )}
      <UitkRadioButtonGroup group={field.primary || ''} selected={selectedFieldValue} onChange={radioClickHandler}>
        {field?.options?.map((option: Options) => (
          <div key={`parent-category-${option.value}`} data-testid={`${option.id}--radio--${option.value}`}>
            <UitkRadioButton
              key={`radio-${option.value}`}
              id={`${option.id}-${option.value}`}
              name={option.id}
              label={option.primary}
              value={option.value}
              labelClassName="uitk-type-300"
            />
          </div>
        ))}
      </UitkRadioButtonGroup>
    </>
  );
});
